import React from 'react'
import EventListener from 'react-event-listener'

const withWidthNumber = (Component) => {
  const resizeInterval = 166; // equiv to 10 frames at 60Hz
  return class WithWidthNumber extends React.Component {
    state = {
      width: null
    }

    componentDidMount() {
      this.updateWidth()
    }

    componentWillUnmount(){
      clearTimeout(this.deferTime)
    }

    handleResize = () => {
      clearTimeout(this.deferTimer)
      this.deferTimer = setTimeout(() => {
        this.updateWidth()
      }, resizeInterval)
    }

    updateWidth() {
      const innerWidth = window.innerWidth;

      this.setState({
        width: innerWidth
      })
    }

    render() {
      const {width} = this.state;

      return(
        <EventListener target="window" onResize={this.handleResize}>
          <Component width={width} {...this.props} />
        </EventListener>
      )
    }
  }
}

export default withWidthNumber;



// WEBPACK FOOTER //
// ./src/utils/withWidthNumber.js